import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense, useState, useEffect, type ReactNode } from "react";
import { isTossApp } from "@/lib/platform";
import { LangProvider } from "@/i18n/LangContext";
import ErrorBoundary from "@/components/ErrorBoundary";

const TDSMobileAITProvider = lazy(() =>
  import("@toss/tds-mobile-ait").then((m) => ({
    default: m.TDSMobileAITProvider,
  }))
);
import { useInterstitialAd } from "@/components/InterstitialAd";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import TossBottomNav from "@/components/TossBottomNav";
import TossBackHandler from "@/components/TossBackHandler";
import HomePage from "@/pages/HomePage";
import DealsPage from "@/pages/DealsPage";
import FreeGamesPage from "@/pages/FreeGamesPage";
import FreeGameDetailPage from "@/pages/FreeGameDetailPage";
import GameDetailPage from "@/pages/GameDetailPage";
import SearchPage from "@/pages/SearchPage";
import StorePage from "@/pages/StorePage";
import TagsPage from "@/pages/TagsPage";
import ReleasesPage from "@/pages/ReleasesPage";
import CalendarPage from "@/pages/CalendarPage";
import PriceComparePage from "@/pages/PriceComparePage";
import ComparePage from "@/pages/ComparePage";
import WishlistPage from "@/pages/WishlistPage";
import ScrollToTop from "@/components/ScrollToTop";

function AppContent() {
  const [toss, setToss] = useState(false);
  useInterstitialAd();
  useEffect(() => { setToss(isTossApp()); }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col overflow-x-hidden">
      <TossBackHandler />
      {/* 토스 인앱은 자체 navbar 있어 헤더 중복 → 숨김 */}
      {!toss && <Header />}
      <main className="flex-1 w-full" style={toss ? { paddingBottom: 72 } : undefined}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/free" element={<FreeGamesPage />} />
          <Route path="/free-games/:id" element={<FreeGameDetailPage />} />
          <Route path="/game/:appId" element={<GameDetailPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/store" element={<StorePage />} />
          <Route path="/tags" element={<TagsPage />} />
          <Route path="/releases" element={<ReleasesPage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/price-compare" element={<PriceComparePage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/wishlist" element={<WishlistPage />} />
        </Routes>
      </main>
      {toss ? <TossBottomNav /> : <Footer />}
      <ScrollToTop />
    </div>
  );
}

function TossWrapper({ children }: { children: ReactNode }) {
  if (!isTossApp()) return <>{children}</>;
  return (
    <Suspense fallback={children}>
      <TDSMobileAITProvider brandPrimaryColor="#3182F6">
        {children}
      </TDSMobileAITProvider>
    </Suspense>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <TossWrapper>
        <LangProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </LangProvider>
      </TossWrapper>
    </ErrorBoundary>
  );
}
